<div class="chat-messages flex-grow-1" #messagesScroll>
  <div class="messages-container">
    <ng-content select="[ui_chat_pinned_message]"></ng-content>

    @for (msg of messages; track msg.id; let ind = $index) {
      <div [class.mt-3]="ind"
           [class.other-message]="msg.type!==messageType"
           [class.my-message]="msg.type===messageType">
        <div class="message-text font-md">
          {{ msg.text }}
        </div>

        @if (msg.attachments?.length) {
          <div class="message-images">
            @for (attachment of msg.attachments; track attachment.id; let last = $last) {
              <div class="msg-img"
                   [class.me-2]="!last"
                   (click)="showImage(attachment.image.originalUrl)">
                <img alt=""
                     loading="lazy"
                     [src]="attachment.id | multiImage: 'smallUrl' : true : ''"
                >
              </div>
            }
          </div>
        }

        <div class="text-end font-xxs font-mute">
          {{ msg.createdAt | i18nDate : 'DD MMM YY HH:mm' }}
        </div>
      </div>
    }

  </div>
</div>

<ng-content select="[ui_chat_footer]"></ng-content>

<div class="chat-input"
     [ngStyle]="{height: chatInputHeight + 'px'}">

  <input #inputFile
         type="file"
         class="d-none"
         accept="image/*, image/heif, image/heic"
         [multiple]="true"
         (change)="onFileInputChanged($event)" />

  <div class="chat-camera"
       (click)="inputFile.click()">
    <i class="icon-camera font-mute"></i>
  </div>

  <div class="type-message flex-grow-1 align-self-center">
    <ui-expandable-textarea
      [styles]="styles"
      [minHeight]="20"
      [placeholder]="placeholder"
      [(model)]="currentMsg.text"
      (onResize)="messageInputResize($event)"
    ></ui-expandable-textarea>
  </div>

  <button class="btn btn-chat-send text-primary"
          [disabled]="sending || (!currentMsg.text && !currentMsg.attachments?.length)"
          (click)="sendMessage()">
    <i class="icon-send"></i>
  </button>
</div>

@if (currentMsg.attachments?.length) {
  <div class="chat-images">
    @for (attachment of currentMsg.attachments; track attachment.id) {
      <div class="chat-img"
           (click)="showImage(attachment.image.originalUrl)">
        <img alt=""
             [src]="attachment.id | multiImage: 'smallUrl' : true : ''"
        >

        <button class="btn btn-danger btn-attachment-delete"
                (click)="deleteAttachment(attachment)">
          <i class="icon-close font-xs"></i>
        </button>
      </div>
    }
  </div>
}

